module.exports = __webpack_public_path__ + "static/media/album.b42fc68a.svg";